































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { FamilyReport } from '@/interfaces/Models';

@Component
export default class FamilyReportDialog extends Vue {

    @Prop() dialog!: boolean;
    @Prop() resource!: FamilyReport | null;
    
    public disabled: boolean = false;

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }
    
    public close() {
        this.$emit('update:dialog', !this.dialog);
    }
}
